import { db } from '@/api/firebase';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { useForm } from 'react-hook-form';

export default function RequestDialog({ open, onClose, leadId, columns = [] }) {
  const { register, handleSubmit, watch, reset, setValue } = useForm();

  const birthDate = watch('birthDate');
  const age = birthDate ? calculateAge(birthDate) : '';

  const onSubmit = async (data) => {
    try {
      const requestData = {
        fullName: data.fullName,
        phone: data.phone,
        birthDate: data.birthDate,
        age,
        temperature: data.temperature,
        note: data.note || '',
        leadId, // lead reference
        columnId: data.columnId, // column reference
        createdAt: serverTimestamp(),
      };

      await addDoc(collection(db, 'requests'), requestData);

      reset();
      onClose();
    } catch (err) {
      console.error('Request save error:', err);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Yangi Request qo‘shish</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div>
            <Label>Ism Familiya</Label>
            <Input {...register('fullName', { required: true })} />
          </div>
          <div>
            <Label>Telefon raqam</Label>
            <Input {...register('phone', { required: true })} type="tel" />
          </div>
          <div>
            <Label>Tug‘ilgan kun</Label>
            <Input {...register('birthDate', { required: true })} type="date" />
            {age && <p className="text-sm mt-1">Yosh: {age} yil</p>}
          </div>
          <div>
            <Label>Harorat</Label>
            <select
              {...register('temperature', { required: true })}
              className="border rounded p-2 w-full"
            >
              <option value="">Tanlang</option>
              <option value="issiq">Issiq</option>
              <option value="iliq">Iliq</option>
              <option value="sovuq">Sovuq</option>
            </select>
          </div>
          <div>
            <Label>Qaysi column</Label>
            <Select onValueChange={(val) => setValue('columnId', val)}>
              <SelectTrigger>
                <SelectValue placeholder="Column tanlang" />
              </SelectTrigger>
              <SelectContent>
                {columns.map((col) => (
                  <SelectItem key={col.id} value={col.id}>
                    {col.title}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>Izoh</Label>
            <Input {...register('note')} />
          </div>
          <div className="flex justify-end gap-2">
            <Button type="button" variant="outline" onClick={onClose}>
              Bekor qilish
            </Button>
            <Button type="submit">Saqlash</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}

function calculateAge(birthDate) {
  const today = new Date();
  const birth = new Date(birthDate);
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
    age--;
  }
  return age;
}
